import React, { FC, ReactElement, useState } from 'react';
import cns from 'classnames';
import styles from './Block.module.scss';

interface BlockProps {
  title: string;
  isOpened?: boolean;
}

const Block: FC<BlockProps> = ({ title, isOpened = true, children }): ReactElement => {
  const [isOpen, setIsOpen] = useState<boolean>(isOpened);

  return (
    <div className={cns('setting-drop-bl', styles.block, isOpen && styles._opened)}>
      <div className="setting-drop-bl__tt" role="button" tabIndex={0} onClick={() => setIsOpen(!isOpen)}>
        {title}
      </div>
      <div className={cns('setting-drop-bl__inner', styles.inner)}>{children}</div>
    </div>
  );
};

export default Block;
